<template>
	<div id="app">
		
		<div class="nav">
			<router-link to='/home' class="navx navlist1">
				<img src="../assets/logo.png" alt="" style="width: 100%;">
			</router-link>
			<router-link to='/home' class="navlist" :class="[$route.path=='/home'?'active':'']">论坛首页</router-link>
			<router-link to='/introduce' class="navlist" :class="[$route.path=='/introduce'?'active':'']">论坛介绍</router-link>
			<router-link to='/annual' class="navlist" :class="[$route.path=='/annual'?'active':'']">论坛视频</router-link>
			<router-link to='/council' class="navlist" :class="[$route.path=='/council'?'active':'']">论坛理事会</router-link>
			<div class="navlist" @click="to1">电子杂志</div>
		<!-- 	<div class="navlist" @click="to2">金融学院</div> -->
			<router-link to='/finance' class="navlist" :class="[$route.path=='/finance'?'active':'']">金融学院</router-link>
			<router-link to='/contact' class="navlist" :class="[$route.path=='/contact'?'active':'']">联系我们</router-link>
		</div>
		<div class="wapheade_bg">
			<div class="wapheade">
				<div class="waplogo"><router-link to='/home' :class="[$route.path=='/home'?'active':'']"><img src="../assets/logo.png" alt=""></router-link></div>
				<div class="mores" @click="drawer = true" type="primary"><img src="../assets/navicon.png"></div>
			</div>
		</div>
		<el-drawer :visible.sync="drawer" :with-header="false">
			<div class="dr_logo"><img src="../assets/logo.png" alt=""></div>
			<div class="dr_list">
				<router-link to='/home' class="list" :class="[$route.path=='/home'?'active':'']">论坛首页 </router-link>
				<router-link to='/introduce' class="list"
					:class="[$route.path=='/introduce'?'active':'']">论坛介绍</router-link>
				<router-link to='/annual' class="list" :class="[$route.path=='/annual'?'active':'']">论坛视频</router-link>
				<router-link to='/council' class="list"
					:class="[$route.path=='/council'?'active':'']">论坛理事会</router-link>
				<div class="list"  @click="to1">电子杂志</div>
				<router-link class="list" to='/finance'>金融学院</router-link>
				<router-link to='/contact' class="list"
					:class="[$route.path=='/contact'?'active':'']">联系我们</router-link>
			</div>
		</el-drawer>
		<router-view></router-view>
		<div class="footer_bg">
			<div class="footer">
				<div class="fot_left">
					<div class="forum">
						<router-link to='/introduce' class="a">
						<div class="intro_title">论坛介绍</div>
						</router-link>
						<router-link to='/annual' class="a">
						<div class="intro_text">论坛视频</div>
						</router-link>
						<router-link to='/council' class="a">
						<div class="intro_text">全体理事</div>
						</router-link>
						<div class="intro_text" @click="to1">电子杂志</div>
					
					</div>
				<!-- 	<div class="forum">
						<div class="intro_title">论坛年会</div>
						<div class="intro_text">2017全球经济的迷途与变局</div>
						<div class="intro_text">2016中国经济</div>
						<div class="intro_text">2015首届复旦首席经济学家论坛</div>
					</div> -->
					<div class="forum">
						<div class="intro_title">联系我们</div>
						<div class="intro_text">电话: 86-21-61110219</div>
						<div class="intro_text">邮箱: CCEF@chinacef.cn</div>
						<div class="intro_text">地址：上海市虹口区东大名路1098号浦江国际金融广场806-7室(秘书处)
						<!-- 	<span>上海市浦东新区盛夏路560号505室(办公室)</span> -->
						</div>
					</div>
				</div>
				<div class="for_right">
					<div class="code">
						<div class="code_img"><img src="../assets/qr_code.png" alt=""><div class="code_text">首席微信公众号</div></div>
						<div class="code_img"><img src="../assets/android.png" alt=""><div class="code_text">首席论坛安卓APP</div></div>
						<div class="code_img"><img src="../assets/ios.png" alt=""><div class="code_text">首席论坛ios APP</div></div>
					<!-- 	<div class="conde_text">中国首席经济学家论坛微信每日最新首席专家咨讯</div> -->
					</div>
				<!-- 	<div class="copyright">版权声明 本网站作品采用知识共享署名-非商业性使用-禁止演绎51La</div> -->
				</div>
			</div>
		</div>
		
		<div class="records">Copyright ©2023 上海极视文化传播有限公司版权所有 <a class="a" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: #fff;">沪ICP备07034620号-11</a></div>
	</div>
</template>

<script>
	import home from './components/home.vue'
	import annual from './components/annual.vue'
	export default {
		name: 'app',
		components: {
			home,
			annual
		},
		data() {
			return {
				drawer: false,
			};
		},
		mounted() {
			this.setTKK()
		
		},
		beforeMount() {
			let script=document.createElement('script')
			script.type='text/javascript',
			script.src='//sdk.51.la/js-sdk-pro.min.js',
			script.id='LA_COLLECT'
			script.text='LA.init({id:"3GAgqYrJJyuXNm52",ck:"3GAgqYrJJyuXNm52"})'
			document.body.appendChild(script)
			let meta=document.createElement('meta')
			meta.name='Keywords',
			meta.content='首席经济学家论坛,CHINACCEF,chinacef.cn,首席经济学家论坛,经济学家论坛,经济论坛',
			document.body.appendChild(meta)
			let meta2=document.createElement('meta')
			meta2.name='Description',
			meta2.content='首席经济学家论坛作为中国经济研究高端智囊的顶级思想平台 ，经济论坛立足于全球视角，着眼于中国经济增长和金融市场发展中的现实问题，促进首席经济学家间思想交流，向投资者传递研究信息，以求成为中国经济金融政策研究的高端咨询智囊。',
			document.body.appendChild(meta2)
		},
		methods:{
			to1(){
				window.open('https://book.yunzhan365.com/bookcase/xafy/index.html')
			},
			to2(){
				window.open('https://www.nbifi.cn')
			},
			setTKK(){
				const isDev = process.env.NODE_ENV === 'development'
				localStorage.setItem('token', isDev ? '5Mlp6YvmuuTjq8uY':'Q2dgHi76kxulu4gU')
				localStorage.setItem('key', isDev ? 'cYg6v3yi' : 'HFaJjnRX')
				//动态测试环境104 生产环境108
				localStorage.setItem('dongtai', isDev ? 104 : 108)
			}
			
		}
	}
	
</script>

<style>
	.el-pagination{
		overflow: scroll;
	}
	body {
		margin: 0;
		padding: 0;
	}
	.a{
		text-decoration: none;
	}
	.code_text{
			width: 100px;
		    text-align: center;
		    color: #fff;
		    font-size: 12px;
	}
	.logo_bg {
		height: 94px;
		line-height: 94px;
		background: linear-gradient(to bottom, #dee4ea, #edf3f9);
	}

	.logo_bg .logo {
		width: 1200px;
		margin: 0 auto;
	}

	.nav {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 25px;
		margin-bottom: 20px;
	}

	.nav .navlist {
		width: 10%;
		height: 50px;
		line-height: 50px;
		background-color: #fff;
		text-align: center;
		border-radius: 10rpx;
		color: #333;
		transition: 0.5s;
		text-decoration: none;
		margin-right: 2%;
	}
	.nav .navlist1 {
		width: 10%;
		height: 50px;
		line-height: 50px;
		background-color: #fff;
		text-align: center;
		border-radius: 10rpx;
		color: #333;
		transition: 0.5s;
		text-decoration: none;
		margin-right: 2%;
	}
	.nav .navlist.active {
		background-color: #5082ff;
		color: #fff;
		text-decoration: none;
	}

	.nav .navlist:hover {
		background-color: #5082ff;
		color: #fff;
		transition: 0.5s;
	}

	.footer_bg {
		background-color: #5082ff;
	}

	.footer_bg .footer {
		width: 1200px;
		margin: 0 auto;
		padding-top: 50px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		padding-bottom: 50px;
	}

	.footer_bg .footer .fot_left {
		display: flex;
		flex-wrap: wrap;
		width: 75%;
	}

	.footer_bg .footer .fot_left .forum {
		margin-right: 55px;
	}

	.footer_bg .footer .fot_left .intro_title {
		font-size: 18px;
		color: #fff;
		margin-bottom: 15px;
	}

	.footer_bg .footer .fot_left .intro_text {
		font-size: 14px;
		color: #fff;
		margin-bottom: 5px;
	}

	.footer_bg .footer .fot_left .intro_text span {
		display: block;
		text-indent: 3em;
		margin-top: 5px;
	}

	.footer_bg .footer .for_right {
		width: 25%;
	}

	.footer_bg .footer .for_right .code {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		align-items: center;
	}
	.footer_bg .footer .for_right .code .code_img {
		width: 25%;
	}
	.footer_bg .footer .for_right .code .code_img img{
		width: 100px;
	}

	.footer_bg .footer .for_right .code .conde_text {
		width: 62%;
		color: #fff;
		font-size: 16px;
	}

	.footer_bg .footer .for_right .copyright {
		font-size: 16px;
		color: rgba(255, 255, 255, 0.7);
		margin-top: 10px;
	}

	.records {
		color: #fff;
		font-size: 14px;
		text-align: center;
		height: 60px;
		line-height: 60px;
		background-color: #628fff;
	}
	.wapheade_bg{
		display: none;
	}
	@media screen and (max-width: 1400px) {
		.logo_bg .logo {
			width: 900px;
		}
	
		.nav {
			width: 900px;
		}
	
		.footer_bg .footer {
			width: 900px;
			padding-bottom: 50px;
		}
	}
	
	@media screen and (max-width: 1000px) {
		.logo_bg .logo {
			width: 750px;
		}
	
		.nav {
			width: 750px;
		}
	
		.nav .navlist {
			font-size: 14px;
			height: 40px;
			line-height: 40px;
		}
	
		.footer_bg .footer .fot_left .forum1 {
			display: none;
		}
	
		.footer_bg .footer {
			width: 750px;
			padding-bottom: 50px;
		}
	
		.footer_bg .footer .for_right {
			width: 40%;
		}
	
		.footer_bg .footer .fot_left {
			display: flex;
			flex-wrap: wrap;
			width: 55%;
		}
	}
	
	@media screen and (max-width: 768px) {
		.logo_bg .logo {
			width: 95%;
			display: none;
		}
	.cou_fig .cou_list{
		flex-direction: column-reverse;
	}
		.nav {
			width: 95%;
			display: none;
		}
	
		.footer_bg .footer .fot_left {
			width: 100%;
		}
	
		.footer_bg .footer .fot_left .forum {
			margin-right: 10px;
			margin-top: 10px;
		}
	
		.footer_bg .footer .for_right {
			width: 100%;
		}
	
		.footer_bg .footer {
			width: 95%;
			padding-bottom: 10px;
			padding-top: 20px;
		}
	
		.footer_bg .footer .fot_left .intro_title {
			margin-bottom: 10px;
		}
	
		.records {
			height: 40px;
			line-height: 40px;
		}
	
		.logo_bg {
			display: none;
		}
	
		.nav {
			display: none;
		}
		.wapheade_bg{
			display: block;
		}
		.wapheade {
			display: flex;
			justify-content: space-between;
			height: 60px;
			background: #fff;
			position: fixed;
			left: 0;
			top: 0;
			width: 100%;
			z-index: 99;
			box-shadow: 0 0 15px rgba(0, 0, 0, .15);
			display: flex;
			align-items: center;
		}
	
		.wapheade .waplogo {
			width: 100px;
			height: 45px;
			margin-left: 15px;
		}
	
		.wapheade .waplogo img {
			width: 100%;
			height: 100%;
		}
	
		.wapheade .mores {
			margin-right: 15px;
		}
	
		.el-drawer__open .el-drawer.rtl {
			width: 300px !important;
		}
	
		.dr_logo {
			color: #fff;
			height: 60px;
			line-height: 60px;
			padding: 0 15px;
			border-bottom: 1px solid #eee;
			display: flex;
			align-items: center;
		}
	
		.dr_logo img {
			width: 100px;
			height: 45px;
		}
	
		.dr_list .list {
			display: block;
			height: 50px;
			line-height: 48px;
			padding: 0 25px;
			color: #666;
			width: 100%;
			border-bottom: 1px solid #eee;
			font-size: 15px;
			text-decoration: none;
		}
	}
	
	@media screen and (max-width: 520px) {
		.footer_bg .footer {
			width: 95%;
			padding-bottom: 10px;
			padding-top: 10px;
		}
	
		.footer_bg .footer .for_right {
			margin-top: 20px;
		}
	
		.footer_bg .footer .for_right .code .conde_text {
			display: none;
		}
	
		.footer_bg .footer .for_right .code .code_img {
			margin: 0 auto;
		}
	
		.footer_bg .footer .fot_left .intro_title {
			margin-bottom: 5px;
			font-size: 16px;
		}
	
		.footer_bg .footer .for_right .copyright {
			font-size: 12px;
			color: rgba(255, 255, 255, 0.7);
			margin-top: 10px;
		}
	
		.records {
			height: 40px;
			line-height: 20px;
			font-size: 12px;
		}
	
	}
</style>
